<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <IntroOperasi
            :detailTop="introRalanOperasi.introRalan"
            :detailBottom="introRalanOperasi.introOperasi"
            :steps="steps"
          />
          <!--form action="/ranap/save" method="POST" enctype="multipart/form-data"-->
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div
                  class="col-md-5 d-flex flex-between"
                  v-if="file_surveilans_old"
                >
                  <h5>Terupload: {{ title }}</h5>
                  <a
                    :href="file_surveilans_old"
                    target="_blank"
                    class="btn btn-outline btn-outline-secondary"
                    >Download</a
                  >
                </div>
                <div class="col-md-5">
                  <FormRow
                    v-for="row in rightForm"
                    v-bind:key="row.colnum + String(Math.random(1023))"
                    :row="row"
                    @handleChange="(e) => handleChange(e)"
                  />
                </div>
                <div class="col-md-2 pt-4">
                  <button
                    @click="handleForm"
                    class="
                      btn btn-primary btn-with-icon-left
                      float-right
                      ml-3
                      text-uppercase
                      mt-2
                      btn-block
                    "
                  >
                    <i class="material-symbols-outlined">check_circle</i>
                    SIMPAN
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import IntroOperasi from "@/components/IntroOperasi.vue";
import Alert from "@/components/Alert.vue";
import { setOperationIntro } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { rightForm } from "@/data/OperasiFormSurveilans.js";
import { dataSurveilans } from "@/data/OperasiForm.js";
export default {
  name: "OperasiFormSurveilans",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Alert,
    IntroOperasi,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataSurveilans,
      title: "",
      detailTop: null,
      rightForm: rightForm,
      operasiLaporan: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      id_laporan: null,
      file_surveilans_old: "",
      formSet: {
        file_surveilans: null,
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      //console.log(valid);
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          //console.log(key+': '+self.formSet[key]);
          if (key != "generate_form") {
            if (self.formSet[key]) {
              if (
                !(
                  key == "file_surveilans" &&
                  self.formSet[key] == self.file_surveilans_old
                )
              ) {
                formData.append(key, self.formSet[key]);
              }
            }
          }
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "operasi/" + this.$route.params.id,
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            // var self=this;
            setTimeout(function() {
              self.saveSuccess = false;
              self.$router.push(
                `/operasi/detail/${self.$route.params.id_ralan}/${self.$route.params.id}?tab=6`
              );
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      //console.log(this.formSet[e.target.name]);
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.rightForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              //console.log('ada datanya');
              if (column.type == "file") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.rightForm = forms[0];
      return valid;
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            if (key == "file_surveilans") {
              self.file_surveilans_old =
                result.data["formatted_file_surveilans"];
              self.title = result.data["file_surveilans"];
            }
            if (key != "generate_form") {
              self.formSet[key] = result.data[key];
            }
          });
          //console.log(self.formSet);
          this.updateForm(
            self.formSet,
            self.rightForm,
            !self.file_surveilans_old
          );
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    updateForm(formset, form, create) {
      let self = this;
      form = form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (formset[column.name]) {
            column.value = formset[column.name];
            if (
              create ||
              (!create && ["file", "image"].indexOf(column.type) < 0)
            ) {
              self.handleChange({
                target: {
                  value: column.value,
                  name: column.name,
                  type: column.type,
                },
              });
            }
          }
          return column;
        });
        return row;
      });
      return form;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    await this.displayData();
    this.formSet["id_operasi"] = this.$route.params.id;
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.operasi.id_ralan}`
        );
        this.ralan = result2.data;
        this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
  },
};
</script>
